import React from "react";
import "./styles.css";

const SreoEmptyView = () => (
  <div className="sreo-screener-empty-view-wrapper">
    <div className="sreo-screener-empty-view-picture-circle-background">
      {/* This is material-icons package https://developers.google.com/fonts/docs/material_icons */}
      <span className="material-icons business-building-picture">location_city</span>
    </div>
    <div className="sreo-screener-empty-view-text">Get started by uploading an SREO template</div>
  </div>
);

export default SreoEmptyView;
